<p-dialog
  header="Transfer learner"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '520px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onHide()">
  <p class="transfer-intro" *ngIf="learner">
  Move <strong>{{ learner.first_name }} {{ learner.last_name }}</strong> to another class or specialty at the same academic level.
  Marks and report cards from the previous placement are kept.
  </p>

  <form [formGroup]="transferForm" class="transfer-form">
    <div class="field">
      <label>Current class</label>
      <p class="readonly-value">{{ currentClassLabel }}</p>
    </div>

    <div class="field" *ngIf="isUniversity">
      <label>Current specialty / series</label>
      <p class="readonly-value">{{ currentSeriesLabel }}</p>
    </div>

    <div class="field" *ngIf="!isUniversity || targetClassrooms.length">
      <label for="targetClass">Target class *</label>
      <p-dropdown
        id="targetClass"
        appendTo="body"
        formControlName="target_classroom_id"
        [options]="targetClassrooms"
        optionLabel="name"
        optionValue="id"
        placeholder="Select target class"
        [showClear]="true"
        styleClass="w-full">
      </p-dropdown>
    </div>

    <div class="field" *ngIf="isUniversity">
      <label for="targetSeries">Target specialty / series</label>
      <p-dropdown
        id="targetSeries"
        appendTo="body"
        formControlName="target_series_id"
        [options]="targetSeriesList"
        optionLabel="name"
        optionValue="id"
        placeholder="Select target specialty (optional if class selected)"
        [showClear]="true"
        styleClass="w-full">
      </p-dropdown>
    </div>

    <div class="field">
      <label for="effectiveSemester">Effective term / semester *</label>
      <p-dropdown
        id="effectiveSemester"
        appendTo="body"
        formControlName="effective_semester_id"
        [options]="semesters"
        optionLabel="name"
        optionValue="id"
        placeholder="Select term"
        styleClass="w-full">
      </p-dropdown>
    </div>

    <div class="field">
      <label for="reason">Reason (optional)</label>
      <textarea
        id="reason"
        pInputTextarea
        formControlName="reason"
        rows="3"
        class="w-full"
        placeholder="e.g. Stream change for third term">
      </textarea>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [text]="true" (onClick)="onHide()"></p-button>
    <p-button
      label="Confirm transfer"
      icon="pi pi-arrow-right-arrow-left"
      severity="primary"
      [loading]="isSubmitting"
      (onClick)="submit()">
    </p-button>
  </ng-template>
</p-dialog>
